// Copyright 2021-2026 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { requireElement } from "./dom.js";

export interface TabConfig {
  buttonId: string;
  panelId: string;
}

/** Wires up a button-driven tab switcher between sibling panels. */
export function initTabs(tabs: readonly TabConfig[]): void {
  const entries = tabs.map((tab) => ({
    button: requireElement<HTMLElement>(`#${tab.buttonId}`),
    panel: requireElement<HTMLElement>(`#${tab.panelId}`),
  }));

  for (const entry of entries) {
    entry.button.addEventListener("click", () => {
      for (const other of entries) {
        const isActive = other === entry;
        other.button.classList.toggle("active", isActive);
        other.panel.classList.toggle("active", isActive);
      }
    });
  }
}
